import { Page } from '../../components';
import { Box } from '@mui/material';
import { CrosswordGame } from '../../games';

function CrosswordPage() {
  return (
    <Page maxWidth="sm" fullHeight>
      <Box sx={{ mt: 3, width: '100%' }}>
        <CrosswordGame />
      </Box>
    </Page>
  );
}

export default CrosswordPage;
